import parse from 'html-react-parser';
import { useState, useEffect } from 'react';
import {
  Grid, Box, Button, Typography, useMediaQuery,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { getCalculatorData } from '../../api/services';
import i18n from '../common/i18n';
import moneyFormatterWithoutDecimals from '../common/FormatterUtil';
import { fillMessageWith } from '../../utils/functionUtils';
import matrixResponse from './matrixResponse.json';
import '../../assests/css/wtStyle.css';
import iconInfo from '../../assests/images/icons/icono-info.svg';
import {
  PERSONAL_ADWORDS_LOAN_URL, getEnv,
} from '../../api/env';

const WtCalculatorNew = () => {
  const ORIGINACION_WT_LINK = getEnv(PERSONAL_ADWORDS_LOAN_URL);
  const isMobile = useMediaQuery('(max-width: 1024px)');

  const StyledButton = styled(Button)(({ size = '32px' }) => ({
    backgroundColor: '#da0067',
    color: 'white',
    padding: '0px',
    minWidth: size,
    minHeight: size,
    width: size,
    height: size,
    fontSize: '32px',
    borderRadius: '3px',
    transition: 'background-color 0.3s, transform 0.3s',
    '&:hover': {
      backgroundColor: '#da0067',
      transform: 'scale(1.05)',
    },
  }));

  const StyledTypography = styled(Typography)({
    fontFamily: 'Poppings',
    fontWeight: '700',
    fontSize: '28px',
    padding: '16px',
    margin: '8px',
    color: '#da0067',
    border: '1px solid #9E9E9E',
    borderRadius: '4px',
  });

  const [amounts, setAmounts] = useState(undefined);
  const [matrix, setMatrix] = useState(undefined);
  const [terms, setTerms] = useState(undefined);
  const [value, setValue] = useState(undefined);
  const [installmentAmountSelected, setInstallmentAmountSelected] = useState(undefined);
  const [termsLastListSelected, setTermsLastListSelected] = useState(undefined);

  const pushEvent = () => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'select_item',
      ecommerce: {
        items: [{
          item_name: 'Tradicional Web',
        }],
      },
    });
  };

  const updateValues = (amountsAux, matrixAux, termsAux, amountSelectedIndexPosition) => {
    const installmentsAmountListAux = matrixAux[amountSelectedIndexPosition];
    const termsListAux = termsAux[amountSelectedIndexPosition];

    setInstallmentAmountSelected(installmentsAmountListAux[installmentsAmountListAux.length - 1]);
    setTermsLastListSelected(termsListAux[termsListAux.length - 1]);

    setValue(amountsAux[amountSelectedIndexPosition]);
  };

  const onClickMinus = () => {
    const actualIndex = amounts.indexOf(value);
    const amountSelectedIndexPositionAux = actualIndex <= 0 ? 0 : actualIndex - 1;
    updateValues(amounts, matrix, terms, amountSelectedIndexPositionAux);
  };

  const onClickPlus = () => {
    const actualIndex = amounts.indexOf(value);
    const amountSelectedIndexPositionAux = actualIndex >= amounts.length - 1 ? amounts.length - 1 : actualIndex + 1;
    updateValues(amounts, matrix, terms, amountSelectedIndexPositionAux);
  };

  const getCalculator = async () => {
    try {
      const { data } = await getCalculatorData();
      setAmounts(data.amounts);
      setMatrix(data.matrix);
      setTerms(data.terms);
      const valueAux = data.amounts[Math.round((data.amounts && data.amounts.length - 1) / 2)];
      updateValues(data.amounts, data.matrix, data.terms, data.amounts.indexOf(valueAux));
    } catch (error) {
      console.error('There was an error!', error);
      setAmounts(matrixResponse.amounts);
    }
  };

  useEffect(() => {
    getCalculator();
  }, []);

  return (
    <Box
      sx={{
        padding: isMobile ? '16px' : '24px',
        width: isMobile ? '100%' : '80%',
        margin: 'auto',
        marginTop: isMobile ? '80px' : '16px',
        marginBottom: '16px',
      }}
    >
      {value !== undefined && (
      <Grid container>
        <Grid item md={4} xs={12} alignContent="center">
          <Typography variant="h3" fontWeight={700}>
            {i18n.wtTitle}
          </Typography>
        </Grid>
        <Grid item md={8} xs={12}>
          <Box className="boxSimulator">

            <Box className="boxSlider">
              <Typography variant="h5" fontWeight={700} className="contentBoxSlider">
                {i18n.wtHowMany}
              </Typography>
              <Box className="contentBoxSlider">
                <Grid container alignItems="center">
                  <Grid item xs={isMobile ? 1.25 : 1} justifyContent="right">
                    <StyledButton onClick={onClickMinus}>-</StyledButton>
                  </Grid>
                  <Grid item xs={isMobile ? 9.5 : 10}>
                    <StyledTypography>
                      {moneyFormatterWithoutDecimals.format(value)}
                    </StyledTypography>
                  </Grid>
                  <Grid item xs={isMobile ? 1.25 : 1} justifyContent="left">
                    <StyledButton onClick={onClickPlus}>+</StyledButton>
                  </Grid>
                </Grid>
                <Typography sx={{ fontSize: isMobile ? '12px' : '14px', fontFamily: 'Open Sans !important' }}>
                  <img src={iconInfo} alt="" width="10px" />
                  {fillMessageWith(i18n.wtMaxAmount, moneyFormatterWithoutDecimals.format(Math.max(...amounts)))}
                </Typography>
              </Box>
            </Box>

            <Typography
              variant="p"
              className="pCalculator pAlign"
              sx={{ fontSize: isMobile ? '14px' : '16px', fontFamily: 'Open Sans !important' }}
            >
              {i18n.wtInstallmentPlanTitle}
            </Typography>
            <Typography variant="h5" mt={0.75} sx={{ fontSize: '20px', fontFamily: 'Open Sans !important' }}>
              {parse(fillMessageWith(
                i18n.wtInstallmentPlanDetail,
                termsLastListSelected,
                moneyFormatterWithoutDecimals.format(installmentAmountSelected),
              ))}
            </Typography>
            <a
              href={ORIGINACION_WT_LINK}
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: 'none', color: 'inherit' }}
            >
              <Button onClick={pushEvent} variant="contained" className="ButtonMagenta buttonCredit">
                <Typography sx={{
                  fontSize: '16px',
                  textTransform: 'none',
                  fontWeight: '700',
                  fontFamily: 'Open Sans !important',
                }}
                >
                  {i18n.wtButtonCreditN}
                </Typography>
              </Button>
            </a>
            <Box mt={1}>
              <Typography sx={{ fontSize: isMobile ? '12px' : '14px', fontFamily: 'Open Sans !important' }}>
                {i18n.wtLegalN}
              </Typography>
            </Box>

          </Box>
        </Grid>
      </Grid>
      )}
    </Box>
  );
};

export default WtCalculatorNew;
